global.transactions = [];


export const transactionLogService = store => next => action => {
    next(action);

    global.transactions.push(action);
};
